import api from "../../services/api";

const adminApiService = {
   
    getAllPlans: async (params = {}) => {
        const response = await api.get('/admin/plans', params);
        console.log(response)
        return response.data;
    },

    getAllDemoReqs: async (params = {}) => {
        const response = await api.get('/admin/demo-requests', params);
        console.log(response)
        return response.data;
    },
    getAllRoles: async (params = {}) => {
        const response = await api.get('/admin/plans/roles/available', params);
        console.log(response)
        return response.data;
    },

    getAllRolesById: async (planId) => {
        const response = await api.get(`/admin/plans/${planId}/roles`);
        console.log(response)
        return response.data;
    },
    getAllVendors: async (params={}) => {
        const response = await api.get(`/admin/vendors`,params);
        console.log(response)
        return response.data;
    },
    getAllOrganiations: async (params={}) => {
        const response = await api.get(`/admin/organizations`,params);
        console.log(response)
        return response.data;
    },

    getCurrencies: async (params) => {
        const response = await api.get(`/admin/currencies`, params)
        console.log(response)
        return response.data;
    },
    createCurrencies: async (payload) => {
        const response = await api.post(`/admin/currencies`, payload)
        console.log(response)
        return response.data;
    },
    updateCurrencies: async (id, payload) => {
        const response = await api.put(`/admin/currencies/${id}`, payload)
        console.log(response)
        return response.data;
    },
    deleteCurrency: async (deleteId) =>{
        const response = await api.delete(`/admin/currencies/${deleteId}`)
        console.log(response)
        return response.data;
    }
};
export default adminApiService